import React, { useState, useEffect } from 'react';
import { Modal, Select, message } from 'antd';
import { baseurl } from '../lib/settings';

const EditionSelectionModal = ({ visible, onClose, onEditionSelected }) => {
    const [editions, setEditions] = useState([]);
    const [selectedEditionUp, setSelectedEditionUp] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            fetchAvailableEditions();
        }
    }, [visible]);

    const fetchAvailableEditions = async () => {
        setLoading(true);
        try {
            const response = await baseurl.get('v3/get_available_editions/by_company');
            setEditions(response.data);
        } catch (error) {
            message.error('Falha ao carregar edições disponíveis');
            console.error('Error fetching editions:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOk = () => {
        if (!selectedEditionUp) {
            message.warning('Selecione uma edição antes de confirmar');
            return;
        }
        onEditionSelected(selectedEditionUp);
        onClose();
    };

    return (
        <Modal
            title="Selecione uma Edição"
            visible={visible}
            onOk={handleOk}
            onCancel={onClose}
            okText="Confirmar"
            cancelText="Cancelar"
        >
            <Select
                style={{ width: '100%' }}
                placeholder="Selecione uma edição"
                loading={loading}
                onChange={(value) => setSelectedEditionUp(value)}
                value={selectedEditionUp}
            >
                {editions.map((edition) => (
                    <Select.Option key={edition.id} value={edition.id}>
                        {edition.description}
                    </Select.Option>
                ))}
            </Select>
        </Modal>
    );
};

export default EditionSelectionModal;